import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
//const EXCEL_TYPE = 'data:application/xls;base64';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class ExcelService {

  constructor() { }

  //With Old Version of File-Saver
  public exportAsExcelFile_old_Obselete(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };

    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile_old_Obselete(excelBuffer, excelFileName);
  }

  //With Old Version of File-Saver
  private saveAsExcelFile_old_Obselete(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  public exportAsExcelFile(json: any[], excelFileName: string): void {

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    var excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', bookSST: false, type: 'binary' });

    FileSaver.saveAs(new Blob([this.getExcelFile(excelBuffer)], { type: '' }), excelFileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  getExcelFile(s: any) {
    var buf = new ArrayBuffer(s.length); var view = new Uint8Array(buf);
    for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF; return buf;
  }


}



// WEBPACK FOOTER //
// ./src/app/core/services/excel.service.ts